import React, { useState } from 'react'
import { Container, Row, Col } from 'reactstrap';
import Consulta from '../components/Forms/Consulta';
import Denuncia from '../components/Forms/Denuncia';
import { Link } from 'react-router-dom';

const HomePage = () => {

    const [showDenuncia, setShowDenuncia] = useState(false);
    const [showConsulta, setShowConsulta] = useState(false);

    return (
        <>
            <Container>
                <Row>
                    <Col className='ms-5'>
                        <h1 className='home__title mt-5'>
                            Formulario Canal denuncias / Consultas
                        </h1>
                        <p className='home__mainText'>El Buzón Ético de Mediaset es una herramienta cuyo objetivo es habilitar un canal de comunicación seguro, anónimo y confidencial para que cualquier persona pueda comunicar conductas y/o actos que pudieran suponer un incumplimiento de los principios y valores recogidos en el Código Ético de la Organización y/o de la legislación vigente. También puede ser utilizado como canal de consultas o sugerencias.
                        Todas las denuncias que se presenten a través de este Buzón podrán ser anónimas, garantizándose en todo momento la confidencialidad de las mismas y el correcto tratamiento de los datos proporcionados conforme a la legislación vigente en materia de Protección de Datos.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className='home__title-forms mt-5'>Tipo de formulario</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="home__form-item mb-0">
                            <div>
                                <div className="home__title-tag">Denuncia</div>
                            </div>
                            <div onClick={() => setShowDenuncia(!showDenuncia)} className={ !showDenuncia ? `btn btn-primary ml-auto` : `btn btn-cancel ml-auto`}>Formulario<i className={ !showDenuncia ? `fas fa-angle-down` : `fas fa-angle-up`}></i></div>
                        </div>
                        {
                            showDenuncia && <Denuncia showDenuncia={ showDenuncia } setShowDenuncia={setShowDenuncia} />
                        }
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="home__form-item mb-0">
                            <div>
                                <div className="home__title-tag">Consulta</div>
                            </div>
                            <div onClick={() => setShowConsulta(!showConsulta)} className={ !showConsulta ? `btn btn-primary ml-auto` : `btn btn-cancel ml-auto`}>Formulario<i className={ !showConsulta ? `fas fa-angle-down` : `fas fa-angle-up`}></i></div>
                        </div>
                        {
                            showConsulta && <Consulta showConsulta={ showConsulta } setShowConsulta={setShowConsulta} />
                        }
                    </Col>
                </Row>
                <Row>
                <Col>
                        <div className="home__form-item mb-2">
                            <div>
                                <div className="home__title-tag">Consultar Denuncia/Consulta</div>
                            </div>
                            <div style={{marginLeft: '630px'}}><Link to={`/buscar-consulta`}><div  className={`btn btn-primary ml-auto`}>Consultar</div></Link></div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <Footer /> */}
        </>
    )
}

export default HomePage
